import React, { useState } from 'react';
import Collapse, { Panel } from 'rc-collapse'
import CSSMotion from 'rc-motion';
import RadioButton from '../form/RadioButton'
import { clsx } from '../../utils/helper';

const PaymentMethodGroup = ({ list, onChange, value, name, className, large }) => {
    const defaultGroupActive = list.findIndex(el => !!el.options.find(opt => opt.value === value))
    const [activeKey, setActiveKey] = useState(defaultGroupActive);

    const handleChange = key => {
        if (key === undefined) {
            return;
        }

        setActiveKey(key);
    }

    return (
        <Collapse
            openMotion={CSSMotion}
            accordion
            defaultActiveKey={[defaultGroupActive]}
            className={clsx('payment-method-group', className, large && 'large')}
            onChange={handleChange}
            activeKey={[ activeKey ]}
        >
            {list.map((group, groupIndex) => (
                <Panel
                    key={groupIndex}
                    header={group.label}
                    headerClass="group-header"
                    className="group-body"
                    showArrow={list.length > 1}
                >
                    {group.options.map((opt, indexOpt) => {
                        const Icon = opt.icon
                        return (
                            <div className="option" key={indexOpt}>
                                <RadioButton
                                    label={
                                        <>
                                            <Icon style={{ width: '22px' }} className="mr-2" /> {opt.label}
                                        </>
                                    }
                                    size="small"
                                    value={opt.value}
                                    onChange={onChange}
                                    checked={value === opt.value}
                                    name={name}
                                />
                            </div>
                        )
                    })}
                </Panel>
            ))}
        </Collapse>
    );
};

export default PaymentMethodGroup;